import {
  formatEther as viemFormatEther,
  formatUnits as viemFormatUnits,
  parseEther as viemParseEther,
  parseUnits as viemParseUnits,
  zeroAddress as viemZeroAddress,
} from "viem";
import { toBigInt } from "./serialize";

export const zeroAddress = viemZeroAddress;

export const formatUnits = (
  value: string | number | bigint,
  decimals: string | number
): string => viemFormatUnits(toBigInt(value), Number(decimals));

export const parseUnits = (
  value: string | number,
  decimals: string | number
): bigint => viemParseUnits(String(value), Number(decimals));

export const formatEther = (value: string | number | bigint): string =>
  viemFormatEther(toBigInt(value));

export const parseEther = (value: string | number): bigint =>
  viemParseEther(String(value));
